<header
    class="sticky top-0 flex w-full bg-white border-gray-200 z-40 dark:border-gray-800 dark:bg-gray-900 xl:border-b">
    <div
        class="relative flex items-center justify-between grow gap-3 px-3 py-3 border-b border-gray-200 dark:border-gray-800 sm:px-4 xl:border-b-0 xl:px-6 lg:py-4">
        <div class="flex items-center gap-4">
            <a [routerLink]="(authState$ | async)?.isLoggedIn ? '/all' : '/'" class="hidden xl:flex flex-shrink-0">
                <img src="/images/logo/Safeword-icon.svg" alt="Safeword Logo" class="h-10 w-auto" />
            </a>

            <nav *ngIf="currentUrl !== '/profile'" class="hidden xl:flex items-center gap-7 ml-8">
                <a *ngIf="!(authState$ | async)?.isLoggedIn" routerLink="/" class="text-md font-medium transition-colors duration-200"
                    routerLinkActive="text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }">
                    Home
                </a>
                <a routerLink="/all" routerLinkActive="text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }"
                    class="text-md font-medium transition-colors duration-200">
                    All
                </a>
                <!-- <a routerLink="/shop" routerLinkActive="text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }"
                    class="text-md font-medium transition-colors duration-200">
                    Shop
                </a> -->
                <a routerLink="/events" routerLinkActive="text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }"
                    class="text-md font-medium transition-colors duration-200">
                    Events
                </a>
                <a routerLink="/blogs" routerLinkActive="text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }"
                    class="text-md font-medium transition-colors duration-200">
                    Blogs
                </a>
                <a routerLink="/posts" routerLinkActive="text-[#D31148]" [routerLinkActiveOptions]="{ exact: true }"
                    class="text-md font-medium transition-colors duration-200">
                    Posts
                </a>
            </nav>
        </div>

        <!-- Global search (title / #hashtag across posts, blogs & events) -->
        <div class="relative hidden max-w-md flex-1 xl:flex mx-4" data-global-search-section>
            <div class="relative w-full">
                <input #globalSearchInputRef type="text" [(ngModel)]="globalSearchText"
                    (ngModelChange)="onGlobalSearchInput($event)" (focus)="onGlobalSearchFocus()"
                    (keydown.enter)="submitGlobalSearch()" placeholder="Search posts, blogs, events or #hashtag…"
                    class="w-full rounded-full border border-[#e8e8e8] bg-[#fafafa] px-4 py-2 pr-9 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-[#D31148] focus:ring-1 focus:ring-[#D31148] transition-colors" />
                <button *ngIf="globalSearchText" type="button" (click)="clearGlobalSearch()"
                    class="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#D31148] transition-colors">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5" stroke-linecap="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
                <svg *ngIf="!globalSearchText" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    class="absolute text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                    <path
                        d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                <!-- Results dropdown -->
                <div *ngIf="showGlobalSearchDrop"
                    class="absolute left-0 right-0 top-full mt-2 z-50 max-h-[70vh] overflow-y-auto rounded-2xl border border-[#e8e8e8] bg-white shadow-theme-lg">

                    <div *ngIf="globalSearchLoading" class="px-4 py-6 text-center text-sm text-gray-400">
                        Searching…
                    </div>

                    <ng-container *ngIf="!globalSearchLoading">
                        <div *ngIf="!globalSearchText" class="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wide">
                            Type to search
                        </div>

                        <div *ngIf="globalSearchText && globalSearchResults.length === 0 && globalSearchProfiles.length === 0" class="px-4 py-6 text-center text-sm text-gray-400">
                            No results for "{{ globalSearchText }}"
                        </div>

                        <!-- Section 1: matched profile(s) -->
                        <ng-container *ngIf="globalSearchProfiles.length > 0">
                            <div class="px-4 pt-2 pb-1 text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
                                Profile
                            </div>
                            <button *ngFor="let profile of globalSearchProfiles" type="button"
                                (click)="goToGlobalSearchProfile(profile)"
                                class="flex w-full items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors">
                                <img [src]="profile.profileImage?.urlSmall ?? profile.profileImage?.urlMedium ?? avatarFallback(profile.displayName)"
                                    [alt]="profile.displayName"
                                    class="h-9 w-9 flex-shrink-0 rounded-full object-cover" />
                                <span class="min-w-0 flex-1">
                                    <span class="block truncate text-sm font-semibold text-gray-800">{{ profile.displayName }}</span>
                                    <span class="block truncate text-xs text-gray-400">&#64;{{ profile.userName }}</span>
                                </span>
                                <span class="flex-shrink-0 rounded-full bg-[#FFD4E0] px-2.5 py-1 text-[10px] font-bold uppercase text-[#D31148]">
                                    View
                                </span>
                            </button>
                            <div class="mx-4 my-1 border-t border-[#f0f0f0]"></div>
                        </ng-container>

                        <!-- Section 2: normal post/blog/event results -->
                        <div *ngIf="globalSearchResults.length > 0" class="px-4 pt-1 pb-1 text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
                            Posts, blogs &amp; events
                        </div>
                        <button *ngFor="let item of globalSearchResults" type="button"
                            (click)="selectGlobalSearchResult(item)"
                            class="flex w-full items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors">
                            <span class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-[10px] font-bold uppercase"
                                [ngClass]="{
                                    'bg-[#FFD4E0] text-[#D31148]': item.type === 'POST',
                                    'bg-[#E0E7FF] text-[#4338CA]': item.type === 'BLOG',
                                    'bg-[#D1FAE5] text-[#047857]': item.type === 'EVENT'
                                }">
                                {{ item.type === 'POST' ? 'P' : item.type === 'BLOG' ? 'B' : 'E' }}
                            </span>
                            <span class="min-w-0 flex-1">
                                <span class="block truncate text-sm font-medium text-gray-700">{{ item.title || ('Untitled ' + item.type) }}</span>
                                <span class="block truncate text-xs text-gray-400">{{ item.type | titlecase }} · &#64;{{ item.user?.userName }}</span>
                            </span>
                        </button>

                        <button *ngIf="globalSearchText" type="button" (click)="submitGlobalSearch()"
                            class="w-full border-t border-[#f0f0f0] px-4 py-3 text-center text-sm font-semibold text-[#D31148] hover:bg-gray-50 transition-colors">
                            See all results for "{{ globalSearchText }}"
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>

        <a [routerLink]="(authState$ | async)?.isLoggedIn ? '/all' : '/'"
            class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 xl:hidden">
            <img src="/images/logo/Safeword-icon.svg" alt="Safeword Logo" class="h-7 w-auto" />
        </a>

        <div class="ml-auto flex items-center gap-1 xl:hidden">
            <button (click)="openMobileSearch()" data-mobile-search-toggle
                class="flex items-center justify-center w-10 h-10 text-gray-700 rounded-xl hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800"
                aria-label="Search">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>

            <button (click)="toggleApplicationMenu()" data-app-menu-toggle
                class="flex items-center justify-center w-10 h-10 text-gray-700 rounded-xl hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800"
                [attr.aria-expanded]="isApplicationMenuOpen" aria-label="Open navigation menu">
                <svg *ngIf="!isApplicationMenuOpen" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M4 7H20M4 12H20M4 17H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
                <svg *ngIf="isApplicationMenuOpen" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
            </button>
        </div>

        <div class="hidden items-center justify-between gap-4 xl:flex">
            <div class="flex items-center gap-2 2xsm:gap-3">
                <div class="relative" *ngIf="(authState$ | async)?.isLoggedIn">
                    <app-share-love-menu (createPost)="openPostModal()" (createEvent)="openEventModal()"
                        (opened)="onShareMenuOpened()"></app-share-love-menu>
                </div>

                <button *ngIf="(authState$ | async)?.isLoggedIn"
                    class="hidden md:flex relative items-center justify-center w-9 h-9 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200"
                    routerLink="/dashboard/chat"
                    aria-label="Chat">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                            stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span *ngIf="(totalUnreadChat$ | async) as cnt"
                        class="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 bg-[#D31148] text-white text-[12px] font-bold rounded-full leading-none">
                        {{ cnt > 99 ? '99+' : cnt }}
                    </span>
                </button>
                <button (click)="toggleNotificationPanel()" *ngIf="(authState$ | async)?.isLoggedIn"
                    class="relative flex items-center justify-center w-9 h-9 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200"
                    aria-label="Notifications">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M10.9134 24.5007C11.7361 25.2267 12.8167 25.6673 14.0002 25.6673C15.1837 25.6673 16.2644 25.2267 17.087 24.5007M21.0002 9.33398C21.0002 7.47747 20.2627 5.69699 18.95 4.38424C17.6372 3.07148 15.8567 2.33398 14.0002 2.33398C12.1437 2.33398 10.3632 3.07148 9.05048 4.38424C7.73772 5.69699 7.00023 7.47747 7.00023 9.33398C7.00023 12.9392 6.09077 15.4076 5.07483 17.0403C4.21787 18.4175 3.78939 19.1061 3.8051 19.2982C3.8225 19.5109 3.86756 19.592 4.03896 19.7192C4.19376 19.834 4.89158 19.834 6.28722 19.834H21.7132C23.1089 19.834 23.8067 19.834 23.9615 19.7192C24.1329 19.592 24.178 19.5109 24.1953 19.2982C24.2111 19.1061 23.7826 18.4175 22.9256 17.0403C21.9097 15.4076 21.0002 12.9392 21.0002 9.33398Z"
                            stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span *ngIf="(unreadNotifCount$ | async) as cnt"
                        class="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 bg-[#D31148] text-white text-[12px] font-bold rounded-full leading-none">
                        {{ cnt > 99 ? '99+' : cnt }}
                    </span>
                </button>
            </div>
            <div class="flex items-center space-x-4" *ngIf="authLoaded">
                <ng-container *ngIf="(authState$ | async) as auth">
                    <ng-container *ngIf="auth.isLoggedIn; else guest">
                        <app-user-dropdown [user]="auth.user" (dropdownOpened)="closeDropdown()"></app-user-dropdown>
                    </ng-container>
                </ng-container>

                <ng-template #guest>
                    <div class="flex items-center space-x-3">
                        <a routerLink="/login"
                            class="px-4 py-2 text-white bg-brand-500 hover:bg-brand-500 rounded-md font-medium transition-colors duration-200">
                            Sign In
                        </a>
                        <span class="text-gray-400">|</span>
                        <a routerLink="/register"
                            class="px-4 py-2 border border-brand-500 text-brand-500 hover:bg-[#FEE0E0] rounded-md font-medium transition-colors duration-200">
                            Sign Up
                        </a>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</header>

<div *ngIf="isApplicationMenuOpen" class="fixed inset-0 z-50 xl:hidden">
    <button type="button" (click)="closeApplicationMenu()" aria-label="Close navigation menu"
        class="absolute inset-0 bg-black/45 backdrop-blur-[2px]"></button>

    <aside data-app-menu-panel
        class="absolute inset-y-0 right-0 flex w-full max-w-[22rem] flex-col bg-white shadow-2xl dark:bg-gray-900">
        <div class="flex items-center border-b border-gray-200 px-5 py-4 dark:border-gray-800"
            style="justify-content: right;">
            <!-- <div class="flex items-center gap-3">
                <img src="/images/logo/Safeword-icon.svg" alt="Safeword Logo" class="h-8 w-auto" />
            </div> -->

            <button type="button" (click)="closeApplicationMenu()"
                class="flex h-10 w-10 items-center justify-center rounded-xl text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-800 dark:hover:text-white"
                aria-label="Close menu">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
            </button>
        </div>

        <div class="flex-1 overflow-y-auto px-5 py-5">
            <nav *ngIf="currentUrl !== '/profile'" class="space-y-2">
                <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Pages</p>
                <a *ngIf="!(authState$ | async)?.isLoggedIn" routerLink="/" (click)="closeApplicationMenu()"
                    class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
                    routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span>Home</span>
                    <span>&rsaquo;</span>
                </a>
                <a routerLink="/all" (click)="closeApplicationMenu()"
                    class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
                    routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span>All</span>
                    <span>&rsaquo;</span>
                </a>
                <!-- <a routerLink="/shop" (click)="closeApplicationMenu()"
                    class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
                    routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span>Shop</span>
                    <span>&rsaquo;</span>
                </a> -->
                <a routerLink="/events" (click)="closeApplicationMenu()"
                    class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
                    routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span>Events</span>
                    <span>&rsaquo;</span>
                </a>
                <a routerLink="/blogs" (click)="closeApplicationMenu()"
                    class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
                    routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span>Blogs</span>
                    <span>&rsaquo;</span>
                </a>
                <a routerLink="/posts" (click)="closeApplicationMenu()"
                    class="flex items-center justify-between rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
                    routerLinkActive="border-[#D31148] bg-rose-50 text-[#D31148]"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <span>Posts</span>
                    <span>&rsaquo;</span>
                </a>
            </nav>

            <div *ngIf="(authState$ | async)?.isLoggedIn" class="mt-6">
                <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Create</p>
                <div class="grid grid-cols-1 gap-3">
                    <button type="button" (click)="openPostModal()"
                        class="flex items-center justify-center rounded-2xl bg-[#D31148] px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#b80e3d]">
                        Create post
                    </button>
                    <a routerLink="/blog/create" (click)="closeApplicationMenu()"
                        class="flex items-center justify-center rounded-2xl border border-[#D31148] px-4 py-3 text-sm font-semibold text-[#D31148] transition-colors hover:bg-rose-50">
                        Create blog
                    </a>
                    <button type="button" (click)="openEventModal()"
                        class="flex items-center justify-center rounded-2xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]">
                        Create event
                    </button>
                </div>
            </div>

            <div *ngIf="(authState$ | async)?.isLoggedIn" class="mt-6">
                <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Connections</p>
                <div class="grid grid-cols-3 gap-3">
                    <a routerLink="/dashboard/chat" (click)="closeApplicationMenu()"
                        class="relative flex h-20 items-center justify-center rounded-2xl border border-gray-200 text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
                        aria-label="Chat">
                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span *ngIf="(totalUnreadChat$ | async) as cnt"
                            class="absolute top-4 right-6 flex min-w-5 h-5 items-center justify-center rounded-full bg-[#D31148] px-1.5 text-[11px] font-bold text-white leading-none">
                            {{ cnt > 99 ? '99+' : cnt }}
                        </span>
                    </a>

                    <!-- <button type="button"
                        class="relative flex h-20 items-center justify-center rounded-2xl border border-gray-200 text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
                        aria-label="Cart">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.3335 2.33398H3.85735C4.14438 2.33398 4.28789 2.33398 4.40338 2.38676C4.50515 2.43328 4.5914 2.50808 4.65184 2.60225C4.72042 2.70912 4.74072 2.85119 4.78131 3.13532L5.3335 7.00065M5.3335 7.00065L6.5607 16.0206C6.71644 17.1653 6.7943 17.7376 7.06795 18.1684C7.30907 18.548 7.65476 18.8498 8.06341 19.0376C8.52717 19.2507 9.10476 19.2507 10.26 19.2507H20.2442C21.3438 19.2507 21.8936 19.2507 22.3429 19.0528C22.7391 18.8784 23.079 18.5971 23.3245 18.2406C23.6029 17.8362 23.7058 17.2961 23.9115 16.2159L25.4558 8.10862C25.5282 7.72843 25.5644 7.53833 25.5119 7.38973C25.4659 7.25938 25.3751 7.14962 25.2556 7.08001C25.1195 7.00065 24.926 7.00065 24.5389 7.00065H5.3335ZM11.6668 24.5007C11.6668 25.145 11.1445 25.6673 10.5002 25.6673C9.85583 25.6673 9.3335 25.145 9.3335 24.5007C9.3335 23.8563 9.85583 23.334 10.5002 23.334C11.1445 23.334 11.6668 23.8563 11.6668 24.5007ZM21.0002 24.5007C21.0002 25.145 20.4778 25.6673 19.8335 25.6673C19.1892 25.6673 18.6668 25.145 18.6668 24.5007C18.6668 23.8563 19.1892 23.334 19.8335 23.334C20.4778 23.334 21.0002 23.8563 21.0002 24.5007Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button> -->

                    <button type="button" (click)="toggleNotificationPanel(); closeApplicationMenu()"
                        class="relative flex h-20 items-center justify-center rounded-2xl border border-gray-200 text-gray-700 transition-colors hover:border-[#D31148] hover:bg-rose-50 hover:text-[#D31148]"
                        aria-label="Notifications">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.9134 24.5007C11.7361 25.2267 12.8167 25.6673 14.0002 25.6673C15.1837 25.6673 16.2644 25.2267 17.087 24.5007M21.0002 9.33398C21.0002 7.47747 20.2627 5.69699 18.95 4.38424C17.6372 3.07148 15.8567 2.33398 14.0002 2.33398C12.1437 2.33398 10.3632 3.07148 9.05048 4.38424C7.73772 5.69699 7.00023 7.47747 7.00023 9.33398C7.00023 12.9392 6.09077 15.4076 5.07483 17.0403C4.21787 18.4175 3.78939 19.1061 3.8051 19.2982C3.8225 19.5109 3.86756 19.592 4.03896 19.7192C4.19376 19.834 4.89158 19.834 6.28722 19.834H21.7132C23.1089 19.834 23.8067 19.834 23.9615 19.7192C24.1329 19.592 24.178 19.5109 24.1953 19.2982C24.2111 19.1061 23.7826 18.4175 22.9256 17.0403C21.9097 15.4076 21.0002 12.9392 21.0002 9.33398Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span *ngIf="(unreadNotifCount$ | async) as cnt"
                            class="absolute top-4 right-6 flex min-w-5 h-5 items-center justify-center rounded-full bg-[#D31148] px-1.5 text-[11px] font-bold text-white leading-none">
                            {{ cnt > 99 ? '99+' : cnt }}
                        </span>
                    </button>
                </div>
            </div>

            <!-- Replace the entire "mt-6 border-t" Account section in the mobile aside panel -->

            <div class="mt-6 border-t border-gray-200 pt-5 dark:border-gray-800" *ngIf="authLoaded">
                <ng-container *ngIf="(authState$ | async) as auth">

                    <!-- ── LOGGED IN ── -->
                    <ng-container *ngIf="auth.isLoggedIn; else mobileGuest">
                        <p class="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">Account</p>

                        <!-- Profile card -->
                        <div class="rounded-2xl border border-gray-200 bg-gray-50 p-4">

                            <!-- Avatar + name row -->
                            <div class="flex items-center gap-3 mb-4">
                                <div class="relative flex-shrink-0">
                                    <img *ngIf="auth.user?.profileImage?.urlSmall || auth.user?.profileImage?.urlMedium"
                                        [src]="auth.user?.profileImage?.urlSmall || auth.user?.profileImage?.urlMedium"
                                        [alt]="auth.user?.displayName"
                                        class="h-12 w-12 rounded-full object-cover border-2 border-white shadow-sm" />
                                    <div *ngIf="!auth.user?.profileImage?.urlSmall && !auth.user?.profileImage?.urlMedium"
                                        class="h-12 w-12 rounded-full bg-[#FFD4E0] border-2 border-white shadow-sm flex items-center justify-center">
                                        <span class="text-lg font-bold text-[#D31148]">
                                            {{ (auth.user?.displayName || auth.user?.userName ||
                                            'U').charAt(0).toUpperCase() }}
                                        </span>
                                    </div>
                                </div>

                                <div class="flex-1 min-w-0">
                                    <p class="text-sm font-bold text-gray-900 truncate">{{ auth.user?.displayName ||
                                        auth.user?.userName }}</p>
                                    <p class="text-xs text-gray-500 truncate">{{ auth.user?.email }}</p>
                                </div>
                            </div>

                            <!-- Action links -->
                            <div class="grid grid-cols-1 divide-y divide-gray-200">

                                <!-- <a (click)="closeApplicationMenu()"
                                    class="flex items-center gap-3 py-3 text-sm font-medium text-gray-700 hover:text-[#D31148] transition-colors group">
                                    <span
                                        class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-xl bg-white border border-gray-200 group-hover:border-[#D31148] group-hover:bg-rose-50 transition-colors shadow-sm">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                            <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor"
                                                stroke-width="1.8" />
                                            <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor"
                                                stroke-width="1.8" />
                                            <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor"
                                                stroke-width="1.8" />
                                            <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor"
                                                stroke-width="1.8" />
                                        </svg>
                                    </span>
                                    Dashboard
                                    <span class="ml-auto text-gray-300 group-hover:text-[#D31148]">&rsaquo;</span>
                                </a> -->

                                <a [routerLink]="['/profile', auth.user?.userName, 'post']"
                                    (click)="closeApplicationMenu()"
                                    class="flex items-center gap-3 py-3 text-sm font-medium text-gray-700 hover:text-[#D31148] transition-colors group">
                                    <span
                                        class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-xl bg-white border border-gray-200 group-hover:border-[#D31148] group-hover:bg-rose-50 transition-colors shadow-sm">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.8" />
                                            <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor"
                                                stroke-width="1.8" stroke-linecap="round" />
                                        </svg>
                                    </span>
                                    My Profile
                                    <span class="ml-auto text-gray-300 group-hover:text-[#D31148]">&rsaquo;</span>
                                </a>

                                <a routerLink="/dashboard/setting" (click)="closeApplicationMenu()"
                                    class="flex items-center gap-3 py-3 text-sm font-medium text-gray-700 hover:text-[#D31148] transition-colors group">
                                    <span
                                        class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-xl bg-white border border-gray-200 group-hover:border-[#D31148] group-hover:bg-rose-50 transition-colors shadow-sm">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8" />
                                            <path
                                                d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
                                                stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                                        </svg>
                                    </span>
                                    Account Settings
                                    <span class="ml-auto text-gray-300 group-hover:text-[#D31148]">&rsaquo;</span>
                                </a>

                                <a routerLink="/dashboard/legal" (click)="closeApplicationMenu()"
                                    class="flex items-center gap-3 py-3 text-sm font-medium text-gray-700 hover:text-[#D31148] transition-colors group">
                                    <span
                                        class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-xl bg-white border border-gray-200 group-hover:border-[#D31148] group-hover:bg-rose-50 transition-colors shadow-sm">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M12 1.5C12.1276 1.5 12.2537 1.52735 12.3697 1.58017L19.8697 5.00517C20.1798 5.14622 20.3846 5.4478 20.3986 5.78814C20.4681 7.47737 20.4041 11.3211 19.1035 14.8459C17.7909 18.4033 15.2265 21.6248 12.3072 22.9309C12.1116 23.019 11.8884 23.019 11.6928 22.9309C8.77352 21.6248 6.20906 18.4033 4.8965 14.8459C3.59586 11.3211 3.53191 7.47737 3.60138 5.78814C3.6154 5.4478 3.82024 5.14622 4.13029 5.00517L11.6303 1.58017C11.7463 1.52735 11.8724 1.5 12 1.5ZM5.09566 6.28936C5.03934 7.90855 5.13389 11.2751 6.30563 14.4718C7.49766 17.724 9.72243 20.4644 12 21.5901C14.2776 20.4644 16.5023 17.724 17.6944 14.4718C18.8661 11.2751 18.9607 7.90855 18.9043 6.28936L12 3.13907L5.09566 6.28936ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V12.5C12.75 12.9142 12.4142 13.25 12 13.25C11.5858 13.25 11.25 12.9142 11.25 12.5V8C11.25 7.58579 11.5858 7.25 12 7.25ZM12 16.5C12.5523 16.5 13 16.0523 13 15.5C13 14.9477 12.5523 14.5 12 14.5C11.4477 14.5 11 14.9477 11 15.5C11 16.0523 11.4477 16.5 12 16.5Z"
                                                fill="currentColor" />
                                        </svg>
                                    </span>
                                    Privacy & Legal
                                    <span class="ml-auto text-gray-300 group-hover:text-[#D31148]">&rsaquo;</span>
                                </a>

                            </div>

                            <!-- Sign out button -->
                            <button type="button" (click)="signOut(); closeApplicationMenu()"
                                class="mt-3 flex w-full items-center justify-center gap-2 rounded-xl border border-red-200 bg-red-50 px-4 py-2.5 text-sm font-semibold text-red-600 transition-colors hover:bg-red-100 active:scale-[0.98]">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" />
                                    <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" />
                                </svg>
                                Sign Out
                            </button>

                        </div>
                    </ng-container>

                    <!-- ── GUEST ── -->
                    <ng-template #mobileGuest>
                        <div class="grid grid-cols-1 gap-3">
                            <a routerLink="/login" (click)="closeApplicationMenu()"
                                class="flex items-center justify-center rounded-2xl bg-brand-500 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-600">
                                Sign In
                            </a>
                            <a routerLink="/register" (click)="closeApplicationMenu()"
                                class="flex items-center justify-center rounded-2xl border border-brand-500 px-4 py-3 text-sm font-semibold text-brand-500 transition-colors hover:bg-[#FEE0E0]">
                                Sign Up
                            </a>
                        </div>
                    </ng-template>

                </ng-container>
            </div>
        </div>
    </aside>
</div>

<div *ngIf="isMobileSearchOpen" class="fixed inset-0 z-50 xl:hidden">
    <button type="button" (click)="closeMobileSearch()" aria-label="Close search"
        class="absolute inset-0 bg-black/45 backdrop-blur-[2px]"></button>

    <div data-mobile-search-panel
        class="absolute inset-x-0 top-0 flex max-h-[85vh] flex-col bg-white shadow-2xl dark:bg-gray-900">
        <div class="flex items-center gap-3 border-b border-gray-200 px-4 py-4 dark:border-gray-800">
            <div class="relative flex-1">
                <input #mobileSearchInputRef type="text" [(ngModel)]="globalSearchText"
                    (ngModelChange)="onGlobalSearchInput($event)"
                    (keydown.enter)="submitGlobalSearch(); closeMobileSearch()"
                    placeholder="Search posts, blogs, events or #hashtag…"
                    class="w-full rounded-full border border-[#e8e8e8] bg-[#fafafa] px-4 py-2.5 pr-9 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-[#D31148] focus:ring-1 focus:ring-[#D31148] transition-colors" />
                <button *ngIf="globalSearchText" type="button" (click)="clearGlobalSearch()"
                    class="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#D31148] transition-colors">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5" stroke-linecap="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
                <svg *ngIf="!globalSearchText" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    class="absolute text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                    <path
                        d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            <button type="button" (click)="closeMobileSearch()"
                class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-800 dark:hover:text-white"
                aria-label="Close search">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
            </button>
        </div>

        <div class="flex-1 overflow-y-auto">
            <div *ngIf="globalSearchLoading" class="px-4 py-6 text-center text-sm text-gray-400">
                Searching…
            </div>

            <ng-container *ngIf="!globalSearchLoading">
                <div *ngIf="!globalSearchText"
                    class="px-4 py-6 text-center text-xs font-semibold text-gray-400 uppercase tracking-wide">
                    Type to search
                </div>

                <div *ngIf="globalSearchText && globalSearchResults.length === 0 && globalSearchProfiles.length === 0"
                    class="px-4 py-6 text-center text-sm text-gray-400">
                    No results for "{{ globalSearchText }}"
                </div>

                <!-- Section 1: matched profile(s) -->
                <ng-container *ngIf="globalSearchProfiles.length > 0">
                    <div class="px-4 pt-3 pb-1 text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
                        Profile
                    </div>
                    <button *ngFor="let profile of globalSearchProfiles" type="button"
                        (click)="goToGlobalSearchProfile(profile)"
                        class="flex w-full items-center gap-3 border-b border-[#f5f5f5] px-4 py-3 text-left hover:bg-gray-50 transition-colors">
                        <img [src]="profile.profileImage?.urlSmall ?? profile.profileImage?.urlMedium ?? avatarFallback(profile.displayName)"
                            [alt]="profile.displayName"
                            class="h-9 w-9 flex-shrink-0 rounded-full object-cover" />
                        <span class="min-w-0 flex-1">
                            <span class="block truncate text-sm font-semibold text-gray-800">{{ profile.displayName }}</span>
                            <span class="block truncate text-xs text-gray-400">&#64;{{ profile.userName }}</span>
                        </span>
                        <span class="flex-shrink-0 rounded-full bg-[#FFD4E0] px-2.5 py-1 text-[10px] font-bold uppercase text-[#D31148]">
                            View
                        </span>
                    </button>
                </ng-container>

                <!-- Section 2: normal post/blog/event results -->
                <div *ngIf="globalSearchResults.length > 0" class="px-4 pt-3 pb-1 text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
                    Posts, blogs &amp; events
                </div>
                <button *ngFor="let item of globalSearchResults" type="button"
                    (click)="selectGlobalSearchResult(item); closeMobileSearch()"
                    class="flex w-full items-center gap-3 border-b border-[#f5f5f5] px-4 py-3 text-left hover:bg-gray-50 transition-colors">
                    <span class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-[10px] font-bold uppercase"
                        [ngClass]="{
                            'bg-[#FFD4E0] text-[#D31148]': item.type === 'POST',
                            'bg-[#E0E7FF] text-[#4338CA]': item.type === 'BLOG',
                            'bg-[#D1FAE5] text-[#047857]': item.type === 'EVENT'
                        }">
                        {{ item.type === 'POST' ? 'P' : item.type === 'BLOG' ? 'B' : 'E' }}
                    </span>
                    <span class="min-w-0 flex-1">
                        <span class="block truncate text-sm font-medium text-gray-700">{{ item.title || ('Untitled ' + item.type) }}</span>
                        <span class="block truncate text-xs text-gray-400">{{ item.type | titlecase }} · &#64;{{ item.user?.userName }}</span>
                    </span>
                </button>

                <button *ngIf="globalSearchText" type="button" (click)="submitGlobalSearch(); closeMobileSearch()"
                    class="w-full border-t border-[#f0f0f0] px-4 py-3 text-center text-sm font-semibold text-[#D31148] hover:bg-gray-50 transition-colors">
                    See all results for "{{ globalSearchText }}"
                </button>
            </ng-container>
        </div>
    </div>
</div>

<app-notification [isOpen]="isNotificationPanelOpen" (closed)="isNotificationPanelOpen = false"></app-notification>

<!-- Create post / Create event dialogs — one shared copy, also used by the dashboard header. -->
<app-create-content-modals></app-create-content-modals>
